/* istanbul ignore file */
import { motion } from 'motion/react'
import styled from 'styled-components'

export const HandContainer = styled(motion.div)`
  position: absolute;
  top: 40%;
  left: 50%;
  z-index: 10;
  pointer-events: none;
`
